export default "__VITE_ASSET__CxI12GuS__"